/* eslint-disable no-undef */
/* eslint-disable no-console */

(function ($) {

	let width = window.innerWidth; // Use Web API.
	let height = window.innerHeight; // Use Web API.

	$(function () {

		/**
		 * Get the URL parameters.
		 * @param {*} name
		 * @returns
		 */
		function getUrlParameter(name) {
			name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
			var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
			var results = regex.exec(location.search);
			return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
		}



		/**
		 * Display the search results.
		 *
		 * @param {*} response_total_hits
		 * @param {*} response_results
		 */
		function setup_search_results_layout(response_total_hits, response_results, data) {

			// Set the properties returned results-title and count.
			if (response_total_hits === 0) {
				// No results found.
				$('#results-title .success').hide();
				$('#results-title .failure').show();

				$('#advanced-search-results-yes-results').hide();
				$('#advanced-search-results-no-results').show();

			} else {
				// Results found.

				// console.log('Results found ...' );

				// These are 'Title' elements.
				$('#results-title .success').show();
				$('#results-title .failure').hide();

				/**
				 * Start
				 * We need to get all unique amenities from all the selected properties.
				 * Store them on #advanced-search-results.
				 */
				// console.log(data);
				let wp_amenities = [];
				$.each(data['correlated_exact'], function (index, value) {
					// loop array and push to wp_amenities
					$.each(value['wp_amenities'], function (index, value) {
						wp_amenities.push(value);
					});
				});
				$.each(data['correlated_close'], function (index, value) {
					// loop array and push to wp_amenities
					$.each(value['wp_amenities'], function (index, value) {
						wp_amenities.push(value);
					});
				});
				// sort wp_amenities
				wp_amenities.sort();

				let display_all_amenities = wp_amenities;

				// remove duplicates
				wp_amenities = wp_amenities.filter(function (item, index, inputArray) {
					return inputArray.indexOf(item) === index;
				});

				let display_amenities = wp_amenities;

				// convert wp_amenities to string
				wp_amenities = wp_amenities.join(',');

				// Store wp_amenities on #advanced-search-results
				$('#advanced-search-results').data('wp_amenities', wp_amenities);
				/**
				 * End
				 */


				// loop array and display in list of checkboxes
				if (display_amenities.length > 0) {
					$.each(display_amenities, function (index, value) {

						let count;

						// check if value is within display_all_amenities
						// if yes, then count the number of times it appears
						if (display_all_amenities.includes(value)) {
							count = display_all_amenities.filter(item => item === value).length;

							// if value = pet-frindly, then move to the next loop
							if ('pet-friendly' === value) {
								return;
							}
						}

						let formattedValue = value.toLowerCase().replace(/\s+/g, '-');
						let formattedLabel = value.replace(/-/g, ' ').replace(/\b\w/g, char => char.toUpperCase());

						if ( 'Tv' === formattedLabel ) {formattedLabel = 'TV';}
						if ( 'Wifi' === formattedLabel ) {formattedLabel = 'WiFi';}

						$('#search_filters .amenities-wrapper h4').show();

						$('#search_filters .amenities-wrapper .form-element-wrapper').append('<div class="form-element element-amenities"><input type="checkbox" name="chc_amenities[]" value="' + formattedValue + '" id="chc_amenities_' + formattedValue + '"><label for="chc_amenities_' + formattedValue + '">' + formattedLabel + ' ('+ count +')</label></div>');
					});
					// Show the amenities.

					/**
					 * Search Results page - check amenities checkboxes.
					 * Check if the URL contains the 'chc_amenities' parameter.
					 * If it does, we need to check the checkboxes that are in the URL.
					 */
					// Get the full URL.
					// let full_url = window.location.href;
					// // Check if the URL contains the 'chc_amenities' parameter.
					// if (full_url.includes('chc_amenities')) {
					// 	// If the URL contains the 'chc_amenities' parameter, then get the value.
					// 	let url_amenities = getUrlParameter('chc_amenities');

					// 	// Convert url_amenities to an array split by comma.
					// 	url_amenities = url_amenities.split(',');

					// 	// Check if the URL amenities are in the display_amenities array.
					// 	// If found, then check the checkbox.
					// 	$.each(url_amenities, function (index, value) {

					// 		if (display_amenities.includes(value)) {
					// 			$('#search_filters .amenities-wrapper .form-element-wrapper input[type="checkbox"][id="chc_amenities_' + value + '"]').prop('checked', true);
					// 		}
					// 	});
					// }
					/**
					 * Currently disabled as it was not filtering on re-searches (e.g. changing dates).
					 */

				} else {
					$('#search_filters .amenities-wrapper').hide();
				}
				// Display the amenities.



				// We append the results, but at this point they are not visible.
				$('#advanced-search-results-yes-results').append(unescape(response_results));
				// We need to make an initial filteration of the properties, before displaying them.



				// Count the number of visible properties.
				let cottage_block_counter = $('#cottage-blocks-container .cottage-block').not('.hide-pets, .hide-guests, .hide-amenities, .hide-bedrooms, .hide-price').length;


				// Set the properties returned count.
				$('#results-title .success #results-count').text(cottage_block_counter + (cottage_block_counter === 1 ? ' property' : ' properties'));
				$('#results-title .success #results-count').data('count', cottage_block_counter);

				// 	// Array could have empty values, so remove them.
				// 	master_filters = master_filters.filter(item => !!item);

				/**
				 * This is a delay to allow SlickSlider to initialize properly before showing the properties.
				 * Properties need to have a height before the slider can be initialized.
				 * Therefore we can only show all the properties after the slider has been initialized.
				 */
				setTimeout(function() {
					// console.log("1 second delay completed.");
					// Do these after the filteration is complete.
					$('#advanced-search-results-checking').hide();

					if (cottage_block_counter > 0) {
						$('#advanced-search-results-no-results').hide();
						$('#advanced-search-results-yes-results .sorting-container').show();
					} else {
						$('#advanced-search-results-no-results').show();
						$('#advanced-search-results-yes-results .sorting-container').hide();
					}

					$('#advanced-search-results-yes-results').addClass('display');

					/**
					 * Check if property archive list has a date value.
					 * If it does, we need to show the price range slider.
					 * If it does not, we do not need to show the price range slider.
					 * This is to prevent the price range slider from showing on the location only search (no date search).
					 */
					if ($('#advanced-search-results').data('arrival-date') !== 0) {
						// Setup the price range slider.
						get_prices_range();
					}

				}, 1000); // 1000 milliseconds = 1 second



				// We set a timeout to allow the properties to be appended to the DOM, before we initialize the slider.
				setTimeout(function () {

					$('#advanced-search-results-yes-results .cottage-block').show();

					// Setup the slider.
					var $slider = $('#advanced-search-results-yes-results .cottage-block .slider');

					// Show the slides after loading, prevents Content Layout Shift.
					$slider.on("init", function ( event, slick ) {
						$slider.css({
							visibility: "visible",
							height: "100%",
						});
					});

					$slider.slick({
						slidesToShow: 1,
						autoplay: false,
						dots: false,
						arrows: true,
						infinite: true,
						lazyLoad: 'anticipated',
					});

				}, 600);

			}
			// Set the properties returned results-title and count.

		}

		// Make function globally accessible.
		// Disables eslint warning on function not being used (when they are called from other files).
		window.setup_search_results_layout = setup_search_results_layout;



		if ($('#single-landing-page-wrapper #advanced-search-results-yes-results').length > 0) {

			setTimeout(function () {

				$('#advanced-search-results-yes-results .cottage-block').removeClass('hide').show();

				// Setup the slider.
				var $slider = $('#advanced-search-results-yes-results .cottage-block .slider');

				// Show the slides after loading, prevents Content Layout Shift.
				$slider.on("init", function ( event, slick ) {
					$slider.css({
						visibility: "visible",
						height: "100%",
					});
				});

				$slider.slick({
					slidesToShow: 1,
					autoplay: false,
					dots: false,
					arrows: true,
					infinite: true,
					lazyLoad: 'anticipated',
				});

			}, 600);

		}


		/**
		 * Cottage Thumbnail Blocks Layout Toggle.
		 */

		$(document).on('click', '.sorting-container .layout button', function () {

			// console.log('Layout button clicked.');

			const $thisButton = $(this);
			const $otherButton = $thisButton.parent().siblings('li').find('button');
			const selectedLayout = $thisButton.attr('name');

			// Update layout
			if (selectedLayout === 'list') {
				$('.results-container > div')
					.removeClass('layout-grid')
					.addClass('layout-list');
			} else if (selectedLayout === 'grid') {
				$('.results-container > div')
					.removeClass('layout-list')
					.addClass('layout-grid');
			}

			// Toggle aria-pressed attributes
			$thisButton.attr('aria-pressed', 'true').addClass('active');
			$otherButton.attr('aria-pressed', 'false').removeClass('active');

			// Optionally, notify screen readers about the change
			$('<span class="sr-only">Layout changed to ' + selectedLayout + '</span>')
				.appendTo($thisButton)
				.delay(1000)
				.queue(function () {
					$(this).remove();
				});
		});

	});

	$(window).on('load', function () {
	});

})(jQuery);
